import classNames from 'classnames';
import { DynamicXupCardStyle } from '../XupCardCollectionDynamic';
import { Eyebrow } from 'src/helpers/Eyebrow';
import Headline from 'src/helpers/Headline/Headline';
import { Subheadline } from 'src/helpers/Subheadline';
import { BodyCopy } from 'src/helpers/BodyCopy';
import ButtonGroup from 'src/helpers/ButtonGroup/ButtonGroup';
import React from 'react';
import ButtonLink from 'src/helpers/Button/buttons/btn--link';
import TimeCard from './TimeCard.helper';
import { cta1ToButtonProps, cta2ToButtonProps } from 'src/helpers/Button';

type EventCardMarkupProps = {
  dynamicXupCardStyle: DynamicXupCardStyle;
  // we can ignore below type error for type Any, as type of value in those object parameters are uncertain
  /* eslint-disable @typescript-eslint/no-explicit-any */
  templateClasses: { [property: string]: any };
  renderingFields: { [key: string]: any };
  /* eslint-enable @typescript-eslint/no-explicit-any */
};

const EventCardMarkup = ({ templateClasses, renderingFields }: EventCardMarkupProps) => {
  const eventDates = renderingFields?.eventdates?.fields?.eyebrowText?.value;

  return (
    <div
      className={classNames(
        'group relative w-full border-t border-gray pt-s',
        templateClasses?.gridItem
      )}
    >
      {/* Event Dates */}
      {eventDates !== '' && (
        <Eyebrow
          classes={templateClasses?.eyebrow}
          fields={{ eyebrowText: { value: eventDates } }}
        />
      )}
      {/* Event Headline */}
      <Headline classes={templateClasses?.headline} {...renderingFields.eventname} />
      {/* Event Description */}
      {renderingFields.eventdescription.fields.body.value && (
        <BodyCopy
          classes={classNames(templateClasses?.body, '!mb-xxs break-words')}
          {...renderingFields.eventdescription}
        />
      )}
      {/* Event Time Card */}
      <TimeCard
        showroomHours={renderingFields?.eventtime?.fields?.subheadlineText?.value}
        classes={templateClasses?.showroomHours?.events}
      />
      {/* Event Address */}
      {renderingFields.eventaddress.fields.subheadlineText.value && (
        <>
          <Subheadline
            classes={classNames(templateClasses?.body, '!font-bold !text-black !font-serif !mb-0')}
            fields={{ subheadlineText: { value: 'Location' } }}
          />
          <Subheadline
            classes={classNames(templateClasses?.body, '!font-serif !mb-0')}
            {...renderingFields.eventaddress}
          />
        </>
      )}
      {/* Event Directions */}
      <ButtonLink
        classes={classNames(templateClasses?.buttonGroup, '!text-body text-darkprimary mb-xxs')}
        field={{
          value: {
            text: 'Directions',
            href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              (renderingFields?.eventaddress?.fields?.subheadlineText?.value || '')
                .trim()
                .replace(/\s+/g, ' ')
            )}`,
            target: '_blank',
          },
        }}
        variant={undefined}
      />
      {/* Event CTA */}
      {renderingFields.eventcta.fields.cta1Link.value.href && (
        <ButtonGroup
          cta1={cta1ToButtonProps(
            renderingFields?.eventcta,
            templateClasses?.buttonGroup.cta1Classes
          )}
          cta2={cta2ToButtonProps(
            renderingFields?.eventcta,
            templateClasses?.buttonGroup.cta2Classes
          )}
          wrapperClasses={templateClasses?.buttonGroup.wrapper}
        />
      )}
    </div>
  );
};

export default EventCardMarkup;
